import { mergeGeometries } from 'three/addons/utils/BufferGeometryUtils.js';

/**
 * `mergeGeometries` refuses to mix indexed and non-indexed inputs, and the
 * instruments are built from both (ExtrudeGeometry is non-indexed, every
 * primitive is indexed). Flatten first, then merge — a violin is a few
 * thousand triangles, so the duplicated vertices cost nothing.
 *
 * Also drops any attribute the others do not have, which is what bites when
 * one part came from a Lathe and another from an Extrude.
 */
export function mergeParts(parts, { groups = false } = {}) {
  const flat = parts.filter(Boolean).map((g) => (g.index ? g.toNonIndexed() : g));
  if (!flat.length) return null;

  // Keep only attributes present in every part, in a stable order.
  const common = Object.keys(flat[0].attributes).filter((name) =>
    flat.every((g) => g.attributes[name]),
  );
  for (const g of flat) {
    for (const name of Object.keys(g.attributes)) {
      if (!common.includes(name)) g.deleteAttribute(name);
    }
  }

  const merged = mergeGeometries(flat, groups);
  if (!merged) {
    throw new Error(
      `[merge] could not merge ${flat.length} parts; attributes: ${common.join(', ')}`,
    );
  }
  merged.computeBoundingSphere();
  return merged;
}
